import './built-constants-439d5572.js';
import './built-loglevel-42c63e3e.js';
import './built-js.cookie-7baadf9c.js';
import { g as getCurrentLocation } from './built-index-750f2ec8.js';

/**
 * Removes the iframe generated from Gorgias chatbox.
 * @see https://docs.gorgias.com/gorgias-chat/chat-install#remove_the_chat_based_on_country_code
 * @param {HTMLIFrameElement} iframe - Gorgias iframe
 */

const removeChatBox = iframe => {
  iframe.remove();
};
/**
 * Hides the Gorgias branding inside the chatbox.
 * The branding text states "Powered by Gorgias."
 * @see https://docs.gorgias.com/gorgias-chat/chat-install#remove_powered_by_gorgias_branding
 * @param {HTMLIFrameElement} iframe - Gorgias iframe
 */


const hideGorgiasBranding = iframe => {
  const head = iframe.contentWindow.document.querySelector('head');

  if ((head == null ? void 0 : head.children.length) > 0) {
    const styles = document.createElement('style');
    styles.textContent = '.logo-wrapper{display: none}';
    head.appendChild(styles);
  }
};
/**
 * Keep checking for the Gorgias chatbox.
 * Once it is available, clear the interval,
 * and handle logic based on location.
 */


const gorgiasChatInterval = window.setInterval(() => {
  const iframe = document.querySelector('#gorgias-web-messenger-container');

  if (iframe) {
    window.clearInterval(gorgiasChatInterval); // This line breaks out of the loop - make sure it's not deleted.

    getCurrentLocation().then(location => {
      if (location.country_code === 'US') {
        hideGorgiasBranding(iframe);
      } else {
        removeChatBox(iframe);
      }
    }).catch(error => {
      console.log('Could not get users location', error.message || error); // If anything fails, assume not part of US

      removeChatBox(iframe);
    });
  }
}, 100);
